import {
  ProductsOverflow,
  ProductsTable,
  ProductsHead,
  ProductBoxTitle,
  ProductBoxState,
  ProductBoxActions,
  ProductsContainer,
  ProductsMsg,
} from "./StylesProducts";

import { useEffect, useContext, useLayoutEffect } from "react";

import { Context } from "../Context/ContextProvider";

import { API_BASE_URL } from "../../config/api";

import ModalEditProduct from "./Modals/ModalEditProduct";
import Loader from "./Loader/Loader";
import HeaderCheckbox from "./Checkbox/HeaderCheckbox";

import Products from "./Products";

import ProductFooterTable from "./ProductFooterTable";
import { useCallback } from "react";

export default function AdminProducts({
  setProducts,
  route,
  products,
  msgProducts,
  category,
  categories,
  state,
  dispatch,
  search,
}) {
  const { refresh, reloadProducts, setDeleteProducts, token } = useContext(Context);

  const allCheckBox = () => {
    const newDeleteProducts = state.allCheck ? [] : products.map((item) => item.id);
    setDeleteProducts(newDeleteProducts);
    dispatch({ type: "setAllCheck", payload: !state.allCheck });
  };

  const modalToggle = () => dispatch({ type: "setModal", payload: !state.modal });

  const handlePagePrev = useCallback(() => {
    if (state.page > 1) {
      dispatch({ type: "setPage", payload: state.page - 1 });
      dispatch({ type: "setOffset", payload: state.limit * (state.page - 2) });
    }
  }, [state.limit, state.page, dispatch]);

  // Effect 1: Fetch max pages count
  useEffect(() => {
    const endpoint = category
      ? `/api/products/category/${category.toUpperCase()}`
      : "/api/products/size";

    fetch(`${API_BASE_URL}${endpoint}`, {
      method: "GET",
      headers: { authorization: token },
    })
      .then((res) => res.json())
      .then((data) => {
        const total = category ? data.length : data.documents;
        const maxPage = total > state.limit ? Math.ceil(total / state.limit) : 1;
        dispatch({ type: "setMaxPage", payload: maxPage });
      });
  }, [state.limit, route, refresh, token, category, dispatch]);

  // Effect 2: Reset pagination when filters change
  useEffect(() => {
    dispatch({ type: "setOffset", payload: 0 });
    dispatch({ type: "setPage", payload: 1 });
  }, [route, category, search, dispatch]);

  // Effect 3: Go to previous page if current page becomes empty
  useEffect(() => {
    if (products.length === 0 && state.page > 1) {
      handlePagePrev();
    }
  }, [products.length, state.page, handlePagePrev]);

  // Effect 4: Fetch products - NO state.loading in deps to avoid infinite loop
  useEffect(() => {
    dispatch({ type: "setLoading", payload: true });

    const categoryParam = category ? `&category=${category}` : "";
    const params = `?limit=${state.limit}&offset=${state.offset}&timestamp=${Date.now()}${categoryParam}`;

    fetch(`${API_BASE_URL}/api/products${route}${params}`, {
      method: "GET",
      headers: { authorization: token },
    })
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        dispatch({ type: "setLoading", payload: false });
        dispatch({ type: "setAllCheck", payload: false });
      });
  }, [refresh, token, route, state.limit, state.offset, setProducts, category, dispatch]);

  useLayoutEffect(() => {
    dispatch({ type: "setHeight", payload: window.innerHeight });
    const handleResize = () => dispatch({ type: "setHeight", payload: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return (
    <>
      <ProductsOverflow>
        <ProductsTable products={products.length}>
          <ProductsHead>
            <HeaderCheckbox type="checkbox" allCheckBox={allCheckBox} allCheck={state.allCheck} />
            <ProductBoxTitle>Producto</ProductBoxTitle>
            <ProductBoxState>Estado</ProductBoxState>
            <ProductBoxActions>Acciones</ProductBoxActions>
          </ProductsHead>
          {state.loading ? (
            <Loader />
          ) : products.length ? (
            <ProductsContainer height={state.height}>
              {products.map((product) => {
                return (
                  <Products
                    key={product.id}
                    product={product}
                    modalToggle={modalToggle}
                    setModalInfo={(type, payload) => dispatch({ type: type, payload: payload })}
                    setDeleteProducts={setDeleteProducts}
                    token={token}
                    reloadProducts={reloadProducts}
                    allCheck={state.allCheck}
                  />
                );
              })}
            </ProductsContainer>
          ) : (
            <ProductsMsg>{msgProducts}</ProductsMsg>
          )}
        </ProductsTable>
      </ProductsOverflow>
      <ProductFooterTable
        state={state}
        setLimit={(type, payload) => dispatch({ type, payload })}
        setPage={(type, payload) => dispatch({ type, payload })}
        setOffset={(type, payload) => dispatch({ type, payload })}
        handlePagePrev={handlePagePrev}
      />
      {state.modal && (
        <ModalEditProduct
          closeModal={modalToggle}
          productInfo={state.modalInfo}
          reloadProducts={reloadProducts}
          token={token}
          categories={categories}
        />
      )}
    </>
  );
}
